<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentWeekly /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentWeekly from '@/components/team/dashboard/modules/report/weekly/ContentWeekly.vue'

export default 
{
  name: 'Weekly',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentWeekly
  }
}
</script>

<style>


</style>